import React from 'react';
import { noop } from 'lodash';
import { Modal } from 'antd';

/**
 * ConfirmModal component - used in multiple places.
 * 
 * @param {Object} props - Props for the ConfirmRollbackModal component.
 * @param {ReactNode} props.children - The content inside the modal.
 * @param {function} props.onCancel - The function to be called when triggering canceling action.
 * @param {function} props.onConfirm - The function to be called when triggering confirming action.
 * @param {string} props.okText - The text for the OK button.
 * @param {string} props.cancelText - The text for the Cancel button.
 * @param {string} props.title - The title of the modal.
 * @param {boolean} props.visible - Indicates if the modal is visible.
 * @param {Object} [props] - Additional props to be spread on the Modal component.
 * @returns {JSX.Element} The ConfirmRollbackModal component.
 * @example
 * <ConfirmModal
        onCancel={onCancel}
        onConfirm={onConfirm}
        okText='OK Text'
        visible={true}
        title='Title'
        cancelText='Cancel Text'
        // ...
        >
        ...
    </ConfirmModal>
 */
function ConfirmModal({ 
    children,
    onCancel, 
    onConfirm,
    okText,
    cancelText,
    title,
    visible,
    ...props 
}) {
    return (
        <Modal
            onCancel={onCancel}
            onOk={onConfirm}
            okText={okText}
            cancelText={cancelText}
            title={title}
            visible={visible}
            open={visible} 
            okButtonProps={{
                className: 'cit-btn primary-type',
                ...(props.okButtonProps || {})
            }}
            cancelButtonProps={{
                className: 'cit-btn link-type cancel-button',
                ...(props.cancelButtonProps || {})
            }}
            { ...props } 
        >
            { children }
        </Modal>
    );
}

ConfirmModal.defaultProps = {
    children: noop,
    onCancel: noop, 
    onConfirm: noop,
    okText: 'OK',
    cancelText: 'Cancel',
    title: 'Title',
    visible: true,
};

export default ConfirmModal;